export enum ShippingAuctionsStatus {
    Ended = 'Ended',
    Upcoming = 'Upcoming',
}

export enum ShippingOption {
    FullService = 'Full Service',
    InHouse = 'In-house',
    Label = 'Label',
    None = 'No Shipping',
}

export enum LiveShippingProvider {
    NLS = 'NLS',
    ShippingSaint = 'Shipping Saint',
    ThePackengers = 'ThePackengers',
}

export type ShippingAuction = {
    catalogId: number;
    houseName: string;
    isWithin48Hours: boolean;
    lotCount: number;
    monthAbbreviationDay: string;
    parsedLots: number;
    primaryShippingDetail: ShippingOption;
    saleEndEstimatedUTC: string;
    secondaryShippingDetail: LiveShippingProvider;
    visibleLots: number;
};

export type ShippingAuctionPayload = {
    filters: Partial<{
        alerts: string[];
        houseId: number;
        houseTypes: string[];
        shippingPartners: LiveShippingProvider[];
        /**
         * `elabel` is used by the backend filter logic.
         * `label` is used by the backend for the catalog services
         * When using this type, make sure to properly convert between `elabel` and `label`
         */
        shippingServices: (ShippingOption | 'elabel')[];
    }>;
    page: number;
    pageSize: number;
    status: ShippingAuctionsStatus;
};

export type ShippingAuctionResponse = {
    error: boolean;
    payload: {
        catalogs: ShippingAuction[];
        page: number;
        pageSize: number;
        total: number;
    };
};

type ShippingAuctionsCatalogInfo = {
    auctions: ShippingAuction[];
    totalCount: number;
};

export type ShippingAuctionsSlice = {
    catalogs: {
        [ShippingAuctionsStatus.Ended]: ShippingAuctionsCatalogInfo;
        [ShippingAuctionsStatus.Upcoming]: ShippingAuctionsCatalogInfo;
    };
    error: {
        [ShippingAuctionsStatus.Ended]: string;
        [ShippingAuctionsStatus.Upcoming]: string;
    };
};

export const defaultShippingAuctionsSlice: ShippingAuctionsSlice = {
    catalogs: {
        [ShippingAuctionsStatus.Ended]: {
            auctions: [],
            totalCount: 0,
        },
        [ShippingAuctionsStatus.Upcoming]: {
            auctions: [],
            totalCount: 0,
        },
    },
    error: {
        [ShippingAuctionsStatus.Ended]: '',
        [ShippingAuctionsStatus.Upcoming]: '',
    },
};
